import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/AppShell";

/**
 * ProtectedRoute — vaatii kirjautuneen käyttäjän.
 *
 *   • Kirjautumaton → /login
 *   • Kirjautunut member joka yrittää mennä pääkäyttäjän sivulle → /kentta
 *   • Owner näkee normaalin AppShellin. Member ei näe AppShellin sivupalkkia
 *     lainkaan — hänen sivunsa renderöidään ilman shellia (kts. FieldRoute).
 */
export default function ProtectedRoute({ children, ownerOnly = false, chromeless = false }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if (ownerOnly && user.role === "member") {
      navigate("/kentta", { replace: true });
      return;
    }
    setReady(true);
  }, [loading, user, navigate, ownerOnly]);

  if (loading || !ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-10 w-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (chromeless) return children;
  return <AppShell>{children}</AppShell>;
}
